export const NAMESPACE = 'FRIENDS_AND_FOLLOWERS/';

export const SET_SOURCE = NAMESPACE + "SET_SOURCE";
export const SET_TYPE = NAMESPACE + "SET_TYPE";
export const SET_MIN_COUNT = NAMESPACE + "SET_MIN_COUNT";
export const SET_SUBPROGRESS = NAMESPACE + 'SET_SUBPROGRESS';
